module.exports = __webpack_public_path__ + "img/LogoDashboard-19.32e84228.svg";